// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Deadband kind for filtering analog data changes.
 */
export enum DeadbandType {
  None_ = 0,
  Absolute = 1,
  Percent = 2,
}
